
(function(){
  function initVidCarousels(){
    document.querySelectorAll('.vid-carousel').forEach(function(car){
      var track=car.querySelector('.vid-track');
      var prev=car.querySelector('.vid-prev');
      var next=car.querySelector('.vid-next');
      if(!track) return;
      function slides(){ return track.querySelectorAll('.vid-slide'); }
      function step(dir){
        var w=track.clientWidth;
        track.scrollBy({left:dir*w,behavior:'smooth'});
      }
      var tmr;
      var thumbWrap=document.getElementById('vidThumbs');
      var thumbs=thumbWrap?[].slice.call(thumbWrap.querySelectorAll('.vthumb')):[];
      function setActive(i){ thumbs.forEach(function(t,j){ t.style.borderColor=(j===i)?'var(--pink-600)':'var(--pink-200)'; }); }
      function currentIndex(){ return Math.round(track.scrollLeft/Math.max(1,track.clientWidth)); }
      function playCentered(){
        var ss=slides(); if(!ss.length) return;
        var idx=currentIndex();
        ss.forEach(function(v,i){ if(i===idx){ var p=v.play&&v.play(); if(p&&p.catch)p.catch(function(){}); } else { v.pause&&v.pause(); } });
        setActive(idx);
      }
      if(prev) prev.addEventListener('click',function(){ step(-1); });
      if(next) next.addEventListener('click',function(){ step(1); });
      thumbs.forEach(function(t,i){ t.addEventListener('click',function(){ track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); setActive(i); setTimeout(playCentered,420); }); });
      track.addEventListener('scroll',function(){ clearTimeout(tmr); tmr=setTimeout(playCentered,120); });
      playCentered();
    });
  }
  if(document.readyState!=='loading') initVidCarousels(); else document.addEventListener('DOMContentLoaded', initVidCarousels);
})();
